import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CookieConsent = () => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already seen the cookie notice
    const cookieNoticeSeen = localStorage.getItem('cookieNoticeSeen');
    if (!cookieNoticeSeen) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcknowledge = () => {
    // Mark that user has seen the notice
    localStorage.setItem('cookieNoticeSeen', 'true');
    localStorage.setItem('cookieNoticeDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1e293b',
        color: '#f8fafc',
        padding: '20px',
        boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        maxWidth: '100%',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#ffffff',
            }}
          >
            Cookie Notice
          </div>
          <div
            style={{
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#cbd5e1',
            }}
          >
            We use <strong>strictly necessary authentication cookies</strong> to keep you logged in and provide a secure experience. 
            These cookies are required for the site to function and cannot be disabled. They are automatically set when you log in 
            and are used only for authentication purposes. Learn more in our{' '}
            <button
              onClick={() => navigate('/privacy')}
              style={{
                color: '#60a5fa',
                textDecoration: 'underline',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit'
              }}
            >
              Privacy Policy
            </button>
            .
          </div>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              flexWrap: 'wrap',
              marginTop: '8px',
            }}
          >
            <button
              onClick={handleAcknowledge}
              style={{
                backgroundColor: '#2563eb',
                color: '#ffffff',
                border: 'none',
                padding: '10px 24px',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#1d4ed8')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#2563eb')}
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
